import { render, staticRenderFns } from "./Walkathon.vue?vue&type=template&id=15e32e4f"
import script from "./Walkathon.vue?vue&type=script&lang=js"
export * from "./Walkathon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports